import {IBaseLookup} from "./Ibase.lookup";

export namespace RoleXStudy {

    export const lookupName: string = "RoleXStudy";

    export interface RoleXStudy {
        roleXStudyKey: number;
        study: number;
        resourceRole: number;
        defaultResourceNumber: number;
        minimumResourceNumber: number;
    }

    export interface RoleXStudyDS extends IBaseLookup {
        roleXStudy: RoleXStudy[];
    }
}
